export default {
  getListOptionsOffers: state => state.listOptionsOffers,
  getRulesOffers: state => state.rulesOffers,
  getOffersSelecteds: state => state.offersSelecteds,
  getOffersMobileSelecteds: state => state.offersMobileSelecteds,
  getOffersTvSelecteds: state => state.offersTvSelecteds,
  getParamsFilter: state => state.paramsFilter,
  getAvaliableNumberOptions: state => state.avaliableNumberOptions,
  getFilterCampaignSelecteds: state => state.filterCampaignSelecteds,
  getOfferBillingDiscount: state => state.offerBillingDiscount,
}
